var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",staticClass:"p-4",attrs:{"id":"modal-status-filter","hide-footer":"","no-close-on-backdrop":"","size":"lg","title":"Statuses"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('div',{staticClass:"d-flex flex-wrap justify-content-start"},_vm._l((_vm.statuses),function(status){return _c('b-badge',{key:status.key,staticClass:"m-50",style:({
        backgroundColor: _vm.getLightBackground(status.color),
        color: status.color,
        fontSize: '0.85rem',
        padding: '0.5rem 0.8rem'
      })},[_vm._v(" "+_vm._s(status.name.toUpperCase())+" ")])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }